module.exports = __webpack_public_path__ + "media/images/pig-eb7b327453d960e1ed4aae45abd90b52.svg";